import { useFormikContext } from "formik";
import { useEffect } from "react";

export default function ScrollToFirstError(): null {
  const { submitCount, isValid } = useFormikContext();
  useEffect(() => {
    const errorField = document.querySelector(".MuiFormLabel-root.Mui-error");
    if (isValid || !errorField) return;

    errorField.scrollIntoView({
      behavior: "smooth",
    });
  }, [submitCount, isValid]);
  return null;
}
